// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore?tab=readme-ov-file#_isempty
export const isEmpty = (obj: unknown) =>
  [Object, Array].includes((obj || ({} as Record<string, unknown>)).constructor as ObjectConstructor) &&
  !Object.entries(obj || ({} as Record<string, unknown>)).length
